import { render, staticRenderFns } from "./DashboardSupervisor.vue?vue&type=template&id=f9005532"
import script from "./DashboardSupervisor.vue?vue&type=script&lang=js"
export * from "./DashboardSupervisor.vue?vue&type=script&lang=js"
import style0 from "./DashboardSupervisor.vue?vue&type=style&index=0&id=f9005532&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports